/**
 * @ngdoc option
 * @name bo.options.controller:BoOptionDetailsController
 *
 * @description
 *
 */

class BoOptionDetailsController {

    constructor($http, $state, $stateParams, Alert, NavService, $q, NavHelper) {
        this.api = $http;
        this.state = $state;
        this.stateParams = $stateParams;
        this.alert = Alert;
        this.navService = NavService;
        this.navHelper = NavHelper;
        this.queue = $q;
        this.optionsStore = null;
        this.model = null;
        this.objectModel = null;

        this.queue.all([
            this._loadObject(),
            this._loadOption()
        ]).then(() => {
            this._updateNavigation();
        }, () => {
            this.state.back();
        })

    }

    _loadObject() {
        return this.api.get(`bo/objects/${this.stateParams.objectId}`).then((response) => {
            this.objectModel = response.data.data;
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
        });
    }

    _loadOption() {
        return this.api.get(`bo/objects/${this.stateParams.objectId}/options/${this.stateParams.id}`).then((response) => {
            this.model = response.data.data;
        }, () => {
            this.alert.error('Error', 'Error while loading bookable option');
        });
    }

    _updateNavigation() {
        if (!this.model) {
            return;
        }

        this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.main', {
            name: this.objectModel.label
        });

        this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.options.details', {
            name: this.model.label
        });

        this.navService.overrideMainSideNavActions([
            {
                key: 'edit-option',
                title: 'Edit',
                icon: 'pencil',
                action: () => {
                    this.editModel();
                }
            }
        ]);
    }

    editModel() {
        this.state.go('app.bo.options.edit', {
            objectId: this.objectModel.id,
            id: this.model.id
        });
    }
}

BoOptionDetailsController.$inject = [
    '$http',
    '$state',
    '$stateParams',
    'Alert',
    'NavService',
    '$q',
    'NavHelper'
];

angular
    .module('festzelt-os.modules.bo.options')
    .controller('BoOptionDetailsController', BoOptionDetailsController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/controllers/details-controller.js